export default "__VITE_ASSET__C8KUzSn7__"